module.exports = __webpack_public_path__ + "img/active-2.d769349d.jpg";